/* @ngInject */
const mySelectIds = (
  utils,
  valueHandler,
  entities,
  $filter
) => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
      myNature: '=',
      mySelectedIds: '=',
      mySelectedData: '=?',
      mySelectedLength: '=?',
      preSelect: '=?',
      sortedBy: '=?',
      displayOrder: '=?',
    },
    template: require('./mySelectIdsMove.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.utils = utils
      $scope.fields = entities[$scope.myNature].metadata.fields
      $scope.isAtLeastOneSelected = !!$scope.preSelect
      $scope.checkbox = {}

      if (valueHandler.isNull($scope.mySelectedIds)) {
        $scope.mySelectedIds = []
      }
      if (valueHandler.isNull($scope.mySelectedData)) {
        $scope.mySelectedData = []
      }
      if (valueHandler.isNull($scope.mySelectedLength)) {
        $scope.mySelectedLength = 0
      }

      $scope.$watch('myData', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if ($scope.mySelectedData)
            $scope.mySelectedData.splice(0, $scope.mySelectedData.length)
          resetCheckbox()
        }
        if ($scope.preSelect) {
          $scope.selectAll()
        }
      }, true)

      $scope.$watch('mySelectedData', (newValue, oldValue) => {
        if (valueHandler.isArray(newValue)) {
          $scope.mySelectedIds.splice(0, $scope.mySelectedIds.length)
          $scope.mySelectedLength = 0
          $scope.setupCheckbox(newValue)
        }
      })

      $scope.setupCheckbox = (selectedData) => {
        resetCheckbox()

        const sortedData = $filter('orderObjectBy')(selectedData, $scope.sortedBy)

        for (let dataIndex = 0; dataIndex < sortedData.length; dataIndex++) {
          const element = sortedData[dataIndex]
          $scope.checkbox[element.id] = true
          $scope.mySelectedIds.push(element.id)

          if (valueHandler.isNumber(element.length)) {
            $scope.mySelectedLength += element.length
          }
        }

        if (!selectedData.length) {
          $scope.isAtLeastOneSelected = false
        } else {
          $scope.isAtLeastOneSelected = true
        }
      }

      const resetCheckbox = () => {
        for (const key in $scope.checkbox) {
          $scope.checkbox[key] = false
        }
      }

      $scope.toogleSelection = () => {
        if ($scope.isAtLeastOneSelected) {
          $scope.deselectAll()
        } else {
          $scope.selectAll()
        }
        $scope.isAtLeastOneSelected = !$scope.isAtLeastOneSelected
      }

      $scope.deselectAll = () => {
        $scope.mySelectedData = []
      }

      $scope.selectAll = () => {
        $scope.mySelectedData = utils.copy($scope.myData)
      }

      $scope.selectItem = (_remove, _item) => {
        if (!_remove) {
          $scope.mySelectedData.push(_item)
          $scope.mySelectedIds.push(_item.id)
          if (valueHandler.isNumber(_item.length)) {
            $scope.mySelectedLength += _item.length
          }
        } else {
          const index = $scope.mySelectedIds.indexOf(_item.id)
          $scope.mySelectedData.splice(index, 1)
          $scope.mySelectedIds.splice(index, 1)
          if (valueHandler.isNumber(_item.length)) {
            $scope.mySelectedLength -= _item.length
          }
        }

        if ($scope.mySelectedData.length === 0) {
          $scope.isAtLeastOneSelected = false
        } else if ($scope.mySelectedData.length === $scope.myData.length) {
          $scope.isAtLeastOneSelected = true
        }
      }

      $scope.order = (_item) => {
        const index = $scope.mySelectedIds.indexOf(_item.id)
        return index > -1 ? index + 1 : ''
      }

      $scope.isSelected = (_item) => {
        const index = $scope.mySelectedIds.indexOf(_item.id)
        return !(index < 0)
      }
    },

    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs) => {
      },
    },
  }
}

export default mySelectIds



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/select/mySelectIdsMove.js